import React from 'react'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Fleet from '../../components/Fleet'

const FleetEn = props => {
  return (
    <div className="page fleet">
      <Helmet
        title={`Best Vehicles for Rental at Budget Nicaragua`}
        meta={[
          {
            name: 'description',
            content:
              'Frequently Asked Questions about car rentals. Contact Us: SJO: +506 2436-2070 / LIR: +506 2436-2071.',
          },
        ]}
        link={[
          {
            rel: 'alternate',
            hreflang: 'en',
            href: './es/fleet/fleet',
          },
        ]}
      />
      <div className="top-bg">
        <Img
          sizes={props.data.imageSharp.sizes}
          style={{ width: '100%', position: 'absolute', zIndex: '-1' }}
        />
      </div>

      <div className="excerpt">
        <h1>Meet Out Fleet</h1>
        <h3>From luxury 4x4 to economy vehicles, we have the car you need.</h3>
      </div>
      <Fleet
        lang={props.pathContext.langKey}
        types={props.data.dataJson.fleetTypes}
        features={props.data.dataJson.fleetFeatures}
        displayFilter={true}
      />
    </div>
  )
}

export const query = graphql`
query FleetEn {
  dataJson(id: { regex: "/fleet/" }) {
    ...FleetData
  }
  imageSharp(id: { regex: "/fleet-top-background2/" }) {
    sizes(maxWidth: 1600) {
      ...GatsbyImageSharpSizes
    }
  }
  allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
    edges {
      node {
        name
        childImageSharp {
          resolutions {
            ...GatsbyImageSharpResolutions
          }
        }
      }
    }
  }
}
`
export default FleetEn


// WEBPACK FOOTER //
// ./src/pages/fleet/index.en.js